import {
  PRESUPUESTADOR_SAVE_CLIENT_BEGIN,
  PRESUPUESTADOR_SAVE_CLIENT_SUCCESS,
  PRESUPUESTADOR_SAVE_CLIENT_FAILURE,
  PRESUPUESTADOR_SAVE_CLIENT_DISMISS_ERROR,
} from './constants'
import axios from 'axios'
import { CLIENTES_ENDPOINT } from 'cfgCommon/endpoints'
import { DEFAULT_CLIENT_BUSINESS_TYPE } from '../../clientes/constants'

export function saveClient(client) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: PRESUPUESTADOR_SAVE_CLIENT_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {

      if(
        client.nombre &&
        client.apellido &&
        client.email &&
        client.telefono
        ) {
        const obj = {
          firstname: client.nombre,
          lastname: client.apellido,
          doctype: client.tipoDoc,
          document: client.documento,
          email: client.email,
          phone: client.telefono,
          client_business_type: client.client_business_type || DEFAULT_CLIENT_BUSINESS_TYPE
        }

      let doRequest = null
      let message = ""
      if(!client.id_cliente) {
        // Si el cliente es nuevo, lo creo
        message = "Creación de Cliente"
        doRequest = axios.post(CLIENTES_ENDPOINT, obj)
      } else {
        // Sino lo modifico
        message = "Modificación de Cliente"
        doRequest = axios.put(CLIENTES_ENDPOINT+'/'+client.id_cliente, obj)
      }
      doRequest.then(
        (res) => {
          dispatch({
            type: PRESUPUESTADOR_SAVE_CLIENT_SUCCESS,
            data: { res, message },
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: PRESUPUESTADOR_SAVE_CLIENT_FAILURE,
            data: { error: err.message },
          });
          reject(err);
        },
      );
      } else {
        dispatch({
          type: PRESUPUESTADOR_SAVE_CLIENT_FAILURE,
          data: { error: "Se deben ingresar todos los datos del cliente" },
        });
        reject({error: "Se deben ingresar todos los datos del cliente"})
      }

    });

    return promise;

  };
}


export function dismissSaveClientError() {
  return {
    type: PRESUPUESTADOR_SAVE_CLIENT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_SAVE_CLIENT_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        saveClientPending: true,
        saveClientError: null,
      };

    case PRESUPUESTADOR_SAVE_CLIENT_SUCCESS:
      // The request is success
      return {
        ...state,
        ...action.data,
        client_id: action.data.res.data.data.id,
        saveClientPending: false,
        saveClientError: null,
      };

    case PRESUPUESTADOR_SAVE_CLIENT_FAILURE:
      // The request is failed
      return {
        ...state,
        saveClientPending: false,
        saveClientError: action.data.error,
      };

    case PRESUPUESTADOR_SAVE_CLIENT_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        saveClientError: null,
      };

    default:
      return state;
  }
}
